import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import Detail from "../../../../main/detail/Detail";
import {
  rsActiveMenu,
  rsProgress,
  rsParentCom,
} from "../../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseExpertAnswer } from "./UseExpertAnswer";
import ExpertAnswerInformation from "./ExpertAnswerInformation";
import ExpertAnswerItems from "./ExpertAnswerItems";

export default function ExpertAnswer(props) {
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { GetExpertAnswer, deleteExpertAnswerItem } = UseExpertAnswer();
  const [model, setModel] = useState();
  const [item, setItems] = useState();

  useEffect(() => {
    if (location.state && location.state.categoryID) {
      setProgress(true);
      GetExpertAnswer(location.state.categoryID, (callback) => {
        setItems(callback.items);
        setModel(callback[0]);
      });
    }
  }, [location.state]);

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: msParentCom.backUrl,
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: msParentCom.parentComs },
          {
            name: "مدیریت" + " " + location.state.componentFaTitle,
            url: "/landingmanagment/landingComponents/expert-answer",
          },
        ],
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <Box>
          <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
            فریم نمایش
          </Typography>
          <ExpertAnswerInformation
            model={model}
            aid={location.state.categoryID}
            callback={() => {
              GetExpertAnswer(model.aid, (callback) => {
                setItems(callback.items);
                setModel(callback[0]);
              });
            }}
          />
        </Box>
        <Box sx={{ mt: 2 }}>
          <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
            پرسش ها
          </Typography>
          <ExpertAnswerItems
            categoryID={model && model.aid}
            itemID={model && model.id}
            items={model && model.items}
            callback={() => {
              GetExpertAnswer(model.aid, (callback) => {
                setItems(callback.items);
                setModel(callback[0]);
              });
            }}
          />
        </Box>
      </Box>
    </Detail>
  );
}
